
import BaseTag from "../BaseTag.vue";
import LayoutService from "../../../services/layout.service";
export default class IziPage extends BaseTag {
  created() {
    LayoutService.setDialog({ show: false, name: "" });
  }
}
